import React from 'react';
import _ from 'lodash';
import { contentfulModels, contentfulViews } from '@glowforge/ui-common';


import './social-cards.less';

const { widgetDefaultProps, widgetPropType, getContentByType } = contentfulModels;
const { getWidget } = contentfulViews;

/**
 * SocialCards custom widget
 * @param {Object} widget WidgetPropType ui-common/models/widget
 */
const SocialCards = ({
  sections,
  model,
}) => {
  const cardsList =
    _.map(getContentByType(sections, 'list'),
      ({ customWidgets, stringSubstitutions, ...listModel }) =>
        getWidget(listModel, customWidgets, stringSubstitutions),
    );

  const cta = _.map(getContentByType(sections, 'buttonLink'), getWidget);

  const scrollText = _.get(model, 'textStrings.media-card-swipe-to-see-more');
  const scrollMessage = scrollText ? (
    <div className='scroll-message'>{scrollText}</div>
  ) : null;

  return (
    <div className='SocialCards'>
      <div className='cards-list'>{cardsList}</div>
      {scrollMessage}
      <div className='cta'>{cta}</div>
    </div>
  );
};

SocialCards.propTypes = { ...widgetPropType };

SocialCards.defaultProps = { ...widgetDefaultProps };

export default SocialCards;




// WEBPACK FOOTER //
// ./app/components/landing/social-cards.jsx